module.exports = __webpack_public_path__ + "img/1.16bab650.png";